<script setup lang="ts">
import ArrowLeftIcon from '~/assets/svg/arrow-left.svg?component'
import ChevronRightIcon from '~/assets/svg/chevron-right.svg?component'

const scrollToTop = () => {
  const scrollDuration = 1500
  const scrollStep = -window.scrollY / (scrollDuration / 15)
  const scrollInterval = setInterval(() => {
    if (window.scrollY !== 0) {
      window.scrollBy(0, scrollStep)
    } else {
      clearInterval(scrollInterval)
    }
  }, 15)
}

useHead({
  title: 'Hakkımızda - Hayrât Eğitim',
  meta: [
    {
      name: 'description',
      content: 'Hayrat Eğitim, Hayrât Vakfı\'nın eğitim faaliyetlerini tek bir çatıda buluşturan; Kur\'an-ı Kerim, Osmanlı Türkçesi ve değerler eğitimi odaklı çevrim içi ve yüz yüze programlar sunan bir öğrenme platformudur.'
    }
  ]
})
</script>

  <template>
    <div class="relative min-h-screen">
      <div class="relative w-full max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 pb-20 sm:pb-28 z-10">
        <!-- Ana İçerik Konteyneri -->
        <div class="relative w-full max-w-[732px] mx-auto pt-6 sm:pt-8">
          <!-- Geri Tuşu - Desktop/Tablet -->
          <NuxtLink
              to="/"
              class="hidden lg:inline-flex items-center justify-center w-14 h-14 text-base font-medium rounded-full text-gray-700 bg-gray-100 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 flex-shrink-0 absolute -left-[96px] top-[28px]"
              aria-label="Geri"
          >
            <ArrowLeftIcon class="w-6 h-6" />
          </NuxtLink>
        <!-- Ana sayfa > Hakkımızda navigasyonu -->
        <nav class="mb-4 sm:mb-[8px] hidden xl:block">
          <ol class="flex items-center space-x-2 text-xs sm:text-sm text-gray-500">
            <li>
              <NuxtLink to="/" class="hover:text-blue-600">Ana sayfa</NuxtLink>
            </li>
            <li>
              <ChevronRightIcon class="w-3 h-3 sm:w-4 sm:h-4" />
            </li>
            <li>
              <button 
                @click="scrollToTop" 
                class="text-gray-900 hover:text-blue-600 transition-colors duration-200 cursor-pointer"
                aria-label="Sayfa başına git"
              >
                Hakkımızda
              </button>
            </li>
          </ol>
        </nav>

        <!-- Geri Tuşu - Mobil/Tablet -->
        <NuxtLink
            to="/"
            class="lg:hidden mb-6 inline-flex items-center justify-center w-[48px] h-[48px] sm:w-[56px] sm:h-[56px] text-sm sm:text-base font-medium rounded-full text-gray-700 bg-gray-100 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 flex-shrink-0"
            aria-label="Geri"
        >
          <ArrowLeftIcon class="w-5 h-5 sm:w-6 sm:h-6" />
        </NuxtLink>

        <!-- Sayfa Başlığı -->
        <h1 class="text-[24px] sm:text-[26px] lg:text-[30px] font-[700] leading-[32px] sm:leading-[36px] lg:leading-[40px] text-black font-inter mb-6 sm:mb-8">
          Hakkımızda
        </h1>

        <!-- İçerik -->
        <div class="text-gray-500 font-inter text-[16px] sm:text-[17px] lg:text-[18px] leading-[24px] sm:leading-[26px] lg:leading-[28px] font-normal space-y-4 sm:space-y-6 mt-6 sm:mt-8">
          <p>
            Hayrat Eğitim, Hayrât Vakfı'nın eğitim faaliyetlerini tek bir çatıda buluşturan; Kur'an-ı Kerim, Osmanlı Türkçesi ve değerler eğitimi odaklı çevrim içi ve yüz yüze programlar sunan bir öğrenme platformudur. Çalışmalarımız, 1974'te Üstadımız Bediüzzaman Said Nursî'nin talebesi Ahmed Hüsrev Altınbaşak tarafından kurulan Hayrât Vakfı'nın "Kur'an hizmeti ve ilim" çizgisinde günümüzde devam etmektedir.
          </p>

          <p>
            Misyonumuz, bireylerin manevi ve kültürel mirasımıza güvenilir kaynaklar üzerinden erişmesini sağlamak; her yaştan insana, bulunduğu yer fark etmeksizin öğrenme imkânı sunmaktır. Bu doğrultuda, çağın imkânlarını kullanarak hem geleneksel hem de dijital eğitim yöntemlerini harmanlıyor; gönüllü eğitimcilerimiz ve güçlü içerik altyapımızla binlerce kişiye ulaşıyoruz.
          </p>

          <p>
            Hayrat Eğitim, yalnızca bilgi aktarmayı değil, aynı zamanda değerleri yaşatmayı da hedefler. Eğitim içeriklerimiz, katılımcıların bilgi düzeyini artırmanın yanı sıra, manevi gelişimlerini destekleyecek şekilde tasarlanır. Böylece, öğrenme süreci salt akademik bir faaliyet olmaktan çıkar; hayatın her alanına dokunan bir kazanıma dönüşür.
          </p>

          <p>
            Vizyonumuz, Kur'an ve ilim hizmetini küresel ölçekte daha geniş kitlelere ulaştırmak, dilimiz ve kültürümüzün zengin mirasını gelecek nesillere aktarmaktır.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

